export const LANDING = '/signin';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const FORGOT_PW = '/forgot-pw';
export const CHANGE_PW = '/change-pw';
export const HOME = '/';
export const ACCOUNT = '/account';
export const ADD_FUEL = '/entry/fuel/:car';
export const ADD_CAR = '/entry/cars/:car?';


// WEBPACK FOOTER //
// ./src/constants/routes.js